import styled from "styled-components";

export const FooterContainer = styled.div`
  background-color: rgb(0, 0, 0);
  display: grid;
  color: white;
  font-family: "Neue Machina";
  max-width: 1400px;
  margin-inline: auto;
  padding: 20px 30px;
  box-sizing: border-box;
  /* height: 100dvh; */
  h1 {
    font-weight: 500;
  }
  p {
    color: #9f9f9f;
  }

  button {
    background: linear-gradient(90deg, #d72ed7, #d11198, #f0ad06);
    padding: 10px 20px;
    border: none;
    border-radius: 10px;
    display: flex;
    align-items: center;
    font-family: "Neue Machina";
    font-weight: 600;
    color: white;
    gap: 10px;
    margin-bottom: 50px;
    cursor: pointer;
  }
`;
export const CircleImg = styled.img`
  border-radius: 50%;
  max-width: 300px;
  max-height: 300px;
`;
export const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  padding-bottom: 50px;
  gap: 40px;
  @media (max-width: 790px) {
    grid-template-columns: 1fr;
  }
`;
